import React from 'react';
import { AreaSVGProps } from '../VehiclePaintMeasurement.types';

/**
 * Komponent SVG dla obszaru C - sedan widok górny (dół)
 */
export const AreaC_Sedan_Top: React.FC<AreaSVGProps> = ({
  fill = '#73C69B',
  stroke = '#73C69B',
  strokeWidth = 2,
  fillOpacity = 0.5,
  className = '',
}) => {
  return (
    <svg
      width="153"
      height="51"
      viewBox="0 0 153 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <filter
          id="filter_area_c_sedan_top"
          x="0"
          y="0"
          width="153"
          height="51"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow"
            result="shape"
          />
        </filter>
      </defs>

      <g filter="url(#filter_area_c_sedan_top)">
        <path
          d="M1.05957 1.73633C7.7725 5.57984 15.4945 9.82119 25.3008 13.3359C38.1373 17.9368 54.4385 21.2744 76.9707 21.2744C99.4862 21.2744 115.552 18.074 128.162 13.6045H128.163C137.794 10.1909 145.341 6.04945 151.979 2.24805C152.022 8.7499 151.99 15.9834 151.912 22.3906C151.804 31.2676 151.611 38.2067 151.449 39.6455C151.388 40.1888 151.348 40.6645 151.312 41.0938C151.273 41.5485 151.237 41.9453 151.188 42.334C143.227 44.5943 131.444 46.4591 118.534 47.7832C104.476 49.2251 89.3682 50 76.9707 50C64.572 50 49.3426 49.2244 35.1621 47.7822C22.0369 46.4474 10.062 44.5645 2.08594 42.2812C1.78598 41.2232 1.60756 40.4335 1.51855 39.6797L1.05957 1.73633Z"
          fill={fill}
          fillOpacity={fillOpacity}
          stroke={stroke}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
          shapeRendering="crispEdges"
        />
      </g>
    </svg>
  );
};
